import React from 'react';

const Weights: React.FC<React.PropsWithChildren<React.SVGProps<SVGSVGElement>>> = () => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#222529"
      fillRule="evenodd"
      d="M18.91 2.503a1.718 1.718 0 0 0-2.827.619l-.188-.188a1.718 1.718 0 1 0-2.43 2.43l5.167 5.169a1.718 1.718 0 1 0 2.43-2.43l-.188-.188a1.719 1.719 0 0 0 .618-2.827L18.91 2.503Zm-1.723.708a.718.718 0 0 1 1.015 0l2.584 2.584A.718.718 0 0 1 19.77 6.81l-2.583-2.584a.718.718 0 0 1 0-1.015Zm-3.015.43a.718.718 0 0 1 1.015 0l5.168 5.169a.718.718 0 0 1-1.015 1.015l-5.168-5.168a.718.718 0 0 1 0-1.016ZM8.1 21.066a1.718 1.718 0 1 0 2.43-2.43l-5.167-5.169a1.718 1.718 0 1 0-2.43 2.43l.188.189a1.719 1.719 0 0 0-.618 2.827l2.584 2.584a1.718 1.718 0 0 0 2.826-.618l.187.187ZM3.64 15.19l1.26 1.26.033.032 2.584 2.584c.01.012.022.023.033.034l1.258 1.258a.718.718 0 1 0 1.015-1.015l-5.168-5.168A.718.718 0 1 0 3.64 15.19Zm-.43 2a.718.718 0 0 1 .994-.021l2.627 2.627a.718.718 0 0 1-1.037.993l-2.583-2.584a.718.718 0 0 1 0-1.015Zm11.485-7.97a.5.5 0 0 1 0 .708l-4.769 4.77a.5.5 0 1 1-.707-.708l4.768-4.77a.5.5 0 0 1 .707 0Zm7.173 6.62a.5.5 0 0 0-.736-.677l-5.149 5.6-2.115-2.324a.5.5 0 1 0-.74.673l2.3 2.527a.75.75 0 0 0 1.106.003l5.334-5.802Z"
    />
  </svg>
);

export default Weights;
